import React, { Component, Fragment } from "react"
import { Formik, Form, Field } from "formik"
import { withRouter } from "../../helpers/withRouter"
import {
  Row,
  ButtonGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Card,
  CardBody,
  Col,
  Input,
  Media,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap"
import ListPageHeader from "../../components/custom/ListPageHeader"
import { MethodType, StatusCodes } from "../../constants/defaultValues"
import ListPage from "../../components/custom/ListPage"
import { homepageImageValidation } from "../../helpers/validations"
import { Message } from "../../helpers/language_helper"
import DropDown from "../../components/custom/DropDown"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import CustomSelectInput from "../../components/Common/CustomSelectInput"
import { getDateTimeString, unixdateconversion } from "../../helpers/utils"
import { Tabs, Tab } from "react-bootstrap"
import { SuccessMessage, ErrorMessage } from "../../helpers/notifications"
import { QueryRequest, MutateRequest } from "../../helpers/service_helper"
import {
  createDepartmentMutation,
  updateDepartmentMutation,
  deleteDepartmentMutation,
  getAllDepartmentsQuery,
  getOneDepartmentQuery,
  fileuploadQuery,
} from "./Queries"
import moment from "moment"
import axios from "axios"
import { Helmet } from "react-helmet-async"
import FileDisplay from "components/custom/FileDisplay"

class HomePageImage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentpage: 1,
      buttonAction: false,
      isLoading: true,
      pageSizeOptions: [10, 50, 100],
      pageLimit: 10,
      totalCount: 0,
      keyField: "ID",
      viewModal: false,
      departmentList: [{ name: "ewu" }],

      listRequestModel: {
        searchString: "",
        sortCondition: null,
        pageNumber: 1,
        pageLimit: 10,
      },
      department: {
        name: "",
        departmentLogoURL: "",
      },
      columns: [
        {
          name: "Name",
          selector: row => row.name,
          sortable: true,
          cell: row => <span>{row.name ? row.name : ""}</span>,
        },
        {
          name: "Image",
          selector: row => row.departmentLogoURL,
          sortable: true,
          cell: row => (
            <span>
              {" "}
              {row.departmentLogoURL ? (
                <FileDisplay Value={row.departmentLogoURL} />
              ) : (
                ""
              )}
            </span>
          ),
        },
        {
          name: Message("active"),
          selector: row => row.isActive,
          sortable: true,
          cell: row => <span>{row.isActive ? "Active" : "InActive"}</span>,
        },
        {
          name: "Action",
          selector: row => row.action,
          sortable: false,
          cell: row => (
            <Row>
              <ButtonGroup className="mb-2" style={{ top: "4px" }}>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  Edit
                </Button>

                <Button
                  outline
                  color="danger"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  Delete
                </Button>
              </ButtonGroup>
            </Row>
          ),
        },
      ],
    }
  }

  componentDidMount() {
    this.getAllDepartments()
  }
  getAllDepartments = async value => {
    // this.setState({
    //   isLoading: true,
    // })
    // const { listRequestModel } = this.state
    // var values = listRequestModel
    // const response = await QueryRequest(getAllDepartmentsQuery, values)
    // var departmentsValue = response?.data?.getAllDepartments?.items
    // if (departmentsValue) {
    //   this.setState({
    //     isLoading: false,
    //     departmentList: departmentsValue,
    //     totalPage:
    //       response?.data?.getAllDepartments?.pagination?.totalCount /
    //       response?.data?.getAllDepartments?.pagination?.pageLimit,
    //     totalCount: response?.data?.getAllDepartments?.pagination?.totalCount,
    //   })
    // } else
    //   this.setState({
    //     isLoading: false,
    //   })
  }

  /** handle list page  start  */
  handleSort = (column, sortDirection) => {
    var sortObj = {}
    sortObj[column.selector] = sortDirection === "asc" ? "asc" : "desc"
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          sortCondition: sortObj,
        },
      },
      function () {
        this.getAllDepartments()
      }
    )
  }

  handlePerRowsChange = async perPage => {
    this.setState(
      {
        pageLimit: perPage,
        pageNumber: 1,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageLimit: perPage,
          pageNumber: 1,
        },
      },
      async function () {
        this.getAllDepartments()
      }
    )
  }

  handlePageChange = async page => {
    this.setState(
      {
        pageNumber: page,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageNumber: page,
        },
      },
      function () {
        this.getAllDepartments()
      }
    )
  }

  searchQueryChanged = search => {
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          searchString: search.target.value,
        },
      },
      function () {
        if (
          this.state.listRequestModel.searchString === "" ||
          this.state.listRequestModel.searchString.length > 2
        ) {
          this.getAllDepartments()
        }
      }
    )
  }

  handleEdit = row => {
    if (row) {
      this.setState({
        department: row,
        manageModal: !this.state.manageModal,
        IsEdited: true,
        Label: "Edit",
      })
    }
  }

  handleSubmit = async values => {
    this.setState({
      buttonAction: true,
    })
    if (typeof values.departmentLogoURL === "object") {
      let fileupload = {
        type: "photo",
        fileName: values.departmentLogoURL?.name,
      }
      const fileUploadresponse = await QueryRequest(fileuploadQuery, fileupload)
      let data = fileUploadresponse?.data?.getUploadUrl

      if (data.status === "Success") {
        axios
          .put(data.url, values.departmentLogoURL, {
            headers: { "Content-Type": values.departmentLogoURL?.type },
          })
          .then(async res => {
            if (res.status.toString() === StatusCodes.Success) {
              var AddData = {
                name: values.name,
                departmentLogoURL: data.url.split("?")[0],
              }
              var EditVal = {
                id: values.id,
                data: {
                  name: values.name,
                  departmentLogoURL: data.url.split("?")[0],
                },
              }
              const response =
                this.state.Label == "Edit"
                  ? await MutateRequest(updateDepartmentMutation, EditVal)
                      .then(r =>
                        SuccessMessage(Message("Department.update.success"))
                      )
                      .catch(e => ErrorMessage(e))
                  : await MutateRequest(createDepartmentMutation, {
                      data: AddData,
                    })
                      .then(r => {})
                      .catch(e => ErrorMessage(e))
              var departmentValue = response?.data
              if (departmentValue || this.state.Label == "Edit") {
                this.setState(
                  {
                    manageModal: !this.state.manageModal,
                    buttonAction: false,
                  },
                  () => this.getAllDepartments()
                )
              } else {
                this.setState(
                  {
                    manageModal: !this.state.manageModal,
                    buttonAction: false,
                  },
                  () => this.getAllDepartments()
                )
                SuccessMessage(Message("Department.add.success"))
              }
            } else {
              ErrorMessage(Message("fieldUpload.error"))
            }
          })
          .catch(err => alert("sdhfgsd"))
      } else {
      }
    } else {
      var AddData = {
        name: values.name,
        departmentLogoURL: values.departmentLogoURL,
      }
      var EditVal = {
        id: values.id,
        data: {
          name: values.name,
          departmentLogoURL: values.departmentLogoURL,
        },
      }
      const response =
        this.state.Label == "Edit"
          ? await MutateRequest(updateDepartmentMutation, EditVal)
              .then(r =>
                SuccessMessage(Message("update.homepageimage.success"))
              )
              .catch(e => ErrorMessage(e))
          : await MutateRequest(createDepartmentMutation, { data: AddData })
              .then(r => {})
              .catch(e => ErrorMessage(e))
      var departmentValue = response?.data
      if (departmentValue || this.state.Label == "Edit") {
        this.setState(
          {
            manageModal: !this.state.manageModal,
            buttonAction: false,
          },
          () => this.getAllDepartments()
        )
      } else {
        this.setState(
          {
            manageModal: !this.state.manageModal,
            buttonAction: false,
          },
          () => this.getAllDepartments()
        )
        SuccessMessage(Message("add.homepageimage.success"))
      }
    }
  }

  addBtnClick = () => {
    this.setState({
      department: {
        name: "",
        departmentLogoURL: "",
      },
      manageModal: !this.state.manageModal,
      Label: "Add",
    })
  }

  toggleDeleteModal = row => {
    this.setState({
      deleteModal: !this.state.deleteModal,
      department: row,
    })
  }

  toggleManageModal = () => {
    this.setState({
      department: {},
      manageModal: !this.state.manageModal,
    })
  }

  toggleEditManageModal = () => {
    this.setState({
      department: {},
      manageEditModal: !this.state.manageEditModal,
    })
  }

  deleteDepartment = async id => {
    var values = {
      id: id,
    }
    const response = await MutateRequest(deleteDepartmentMutation, values)
    var departmentdeleteValue = response?.data
    if (departmentdeleteValue.deleteOneDepartment.status === "Success") {
      SuccessMessage(Message("delete.homepageimage.success"))
      this.getAllDepartments()
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    }
  }

  manageDepartmentResponse = data => {
    if (data.statusCode === StatusCodes.Success) {
      this.state.department.id
        ? SuccessMessage(Message("Department.update"))
        : SuccessMessage(Message("Department.add"))

      this.getAllDepartments()
      this.setState({
        buttonAction: false,
        manageModal: !this.state.manageModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
      })
    }
  }

  toggleViewModal = url => {
    this.setState({
      viewModal: !this.state.viewModal,
      documentView: url,
      departmentDetail: url ? url : "",
    })
  }

  render() {
    const initialValues = this.state.department
    const conditionalRowStyles = [
      {
        when: row => row,
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    ]
    return (
      <Fragment>
        <div className="page-content">
          <Helmet>
            <title>Department</title>
          </Helmet>
          <div className="container-fluid">
            <Card>
              <CardBody>
                <div className="PoliceView">
                  <ListPageHeader
                    heading={`${"Home"}.${"Department"}`}
                    buttonText={Message("add.homepageimage")}
                    onTextChange={this.searchQueryChanged}
                    buttonClick={this.addBtnClick}
                    searchValue={this.state.listRequestModel.searchString}
                  />
                </div>
                <Row></Row>
                <div className="PoliceView">
                  <ListPage
                    conditionalRowStyles={conditionalRowStyles}
                    columns={this.state.columns}
                    data={this.state.departmentList}
                    keyField={this.state.keyField}
                    totalCount={this.state.totalCount}
                    rowClicked={this.HandleRowClicked}
                    onSort={this.handleSort}
                    rowsPerPageOnChange={this.handlePerRowsChange}
                    pageChange={this.handlePageChange}
                    // isDataLoading={this.state.isLoading}
                    overFlowXRemoval={true}
                  />
                </div>
              </CardBody>
            </Card>

            <Modal
              isOpen={this.state.deleteModal}
              toggle={this.toggleDeleteModal}
            >
              <ModalHeader toggle={this.toggleDeleteModal}>
                {Message("delete.homepageimage")}
              </ModalHeader>

              <ModalBody>
                <Fragment>
                  <Row className="mb-4">
                    <Label className="av-label ms-3">
                      <h5>
                        {Message("delete.confirmation")} {""}
                        Department "{""}
                        <b>
                          {" "}
                          {this.state.department
                            ? this.state.department.name
                            : ""}
                        </b>{" "}
                        " ?
                      </h5>
                    </Label>
                  </Row>
                </Fragment>
              </ModalBody>

              <ModalFooter>
                <FormGroup className="float-sm-right ">
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() =>
                      this.deleteDepartment(this.state.department.id)
                    }
                  >
                    {Message("yes")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => this.toggleDeleteModal()}
                  >
                    {Message("no")}
                  </Button>
                </FormGroup>
              </ModalFooter>
            </Modal>

            <Modal
              isOpen={this.state.manageModal}
              toggle={this.toggleManageModal}
              size="md"
            >
              <ModalHeader toggle={this.toggleManageModal}>
                {this.state.Label == "Edit"
                  ? Message("update.homepageimage")
                  : Message("add.homepageimage")}
              </ModalHeader>
              <br />

              <Formik
                initialValues={initialValues}
                validationSchema={homepageImageValidation}
                onSubmit={this.handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <ModalBody>
                      <Fragment>
                        <Row>
                          <Col lg="12" sm="12" md="12" xl="12">
                            <FormGroup className="form-group has-float-label">
                              <Label className="requiredField">
                                {Message("name")}
                              </Label>
                              <Field
                                className="form-control"
                                name="name"
                                type="text"
                              />
                              {errors.name && (
                                <div className="invalid-feedback d-block">
                                  {errors.name}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col lg="6" sm="12" md="12">
                            <FormGroup className="form-group has-float-label">
                              <Label className="requiredField">
                                {Message("image")}
                              </Label>
                              <FormGroup>
                                <Input
                                  style={{ display: "none" }}
                                  id="Image"
                                  type="file"
                                  name="departmentLogoURL"
                                  onChange={e => {
                                    this.setState({
                                      photo: e.target.files[0],
                                    })
                                    setFieldValue("image", e.target.files[0])
                                  }}
                                />
                                <label for="Image" class="btn btn-secondary">
                                  <i class="far fa-file"></i>
                                </label>
                                <br />
                                {values.image ? (
                                  <Label>{values.image?.name}</Label>
                                ) : (
                                  ""
                                )}
                                {errors.image && (
                                  <div className="invalid-feedback d-block">
                                    {errors.image}
                                  </div>
                                )}
                                {values.image && this.state.Label == "Edit" ? (
                                  <FileDisplay Value={values.image} />
                                ) : (
                                  ""
                                )}
                              </FormGroup>
                            </FormGroup>
                          </Col>
                          <Col lg="6" sm="12" md="12">
                            <Label className="mt-1 ">{Message("active")}</Label>
                            <FormGroup className="custom-control custom-switch mt-1 ms-2">
                              <Input
                                autoComplete="off"
                                type="checkbox"
                                className="custom-control-input ms-2 "
                                id="IsActive"
                                defaultChecked={values.isActive}
                                onChange={e => {
                                  setFieldValue(`isActive`, e.target.checked)
                                }}
                                onClick={e => {
                                  setFieldValue("isActive", !values.IsActive)
                                }}
                              />
                              <Label
                                className="custom-control-label"
                                htmlFor="IsActive"
                              ></Label>
                              {errors.isActive && (
                                <div className="invalid-feedback d-block">
                                  {errors.isActive}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Fragment>
                    </ModalBody>
                    <ModalFooter>
                      <div className="container-fluid">
                        <Row>
                          <Col lg="">
                            <Label>
                              <span
                                style={{
                                  color: "red",
                                }}
                              >
                                *{" "}
                              </span>
                              {Message("mandatoryFields")}
                            </Label>
                          </Col>

                          <FormGroup className="float-end ">
                            {this.state.Label == "Edit" ? (
                              <Button
                                type="submit"
                                color="primary"
                                className={`btn-shadow btn-multiple-state ${
                                  this.state.buttonAction ? "show-spinner " : ""
                                }`}
                              >
                                {" "}
                                <span className="spinner d-inline-block">
                                  <span className="bounce1" />
                                  <span className="bounce2" />
                                  <span className="bounce3" />
                                </span>
                                <span className="label ">
                                  {Message("update")}
                                </span>
                              </Button>
                            ) : (
                              <Button
                                type="submit"
                                color="primary"
                                className={`btn-shadow btn-multiple-state ${
                                  this.state.buttonAction ? "show-spinner " : ""
                                }`}
                              >
                                {" "}
                                <span className="spinner d-inline-block">
                                  <span className="bounce1" />
                                  <span className="bounce2" />
                                  <span className="bounce3" />
                                </span>
                                <span className="label ">{Message("add")}</span>
                              </Button>
                            )}

                            <Button
                              color="danger"
                              className="ms-2"
                              onClick={() => this.toggleManageModal()}
                            >
                              {Message("cancel")}
                            </Button>
                          </FormGroup>
                        </Row>
                      </div>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withRouter(HomePageImage)
